module.exports = __webpack_public_path__ + "media/images/fc-picture-8ef95b66076cf29c8175b65e606316e3.jpg";